import React from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';

// import { Container } from './styles';

import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component?: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  children,
  ...rest
}) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  return (
    <ReactDOMRoute
      {...rest}
      render={
        ({ location }) =>
          isPrivate === !!user ? (
            Component ? (
              <Component />
            ) : (
              children
            )
          ) : (
            <Redirect
              to={{
                pathname: isPrivate ? '/sign-in' : '/dashboard',
                state: { from: location },
              }}
            />
          )
        // eslint-disable-next-line react/jsx-curly-newline
      }
    />
  );
};

export default Route;
